export const GOOGLE_TAG_MANAGER_API_KEY = process.env.REACT_APP_GTM_API_KEY;

export default GOOGLE_TAG_MANAGER_API_KEY;
